module.exports = __webpack_public_path__ + "static/media/lee.a9044dbc.jpg";